// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4c98f021","389":"a2f5040a","450":"0b68f1dc","453":"5a45ced6","732":"9d707813","857":"fcf95c16","977":"97727f64"}[chunkId] + ".chunk.js";
};